export default __webpack_public_path__ + "static/Swift-Prototyping-9cc8b2a76a53818146f1b652ec64a551.webp";